"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var connectors;
            (function (connectors) {
                class InitArgs {
                    constructor() {
                        this.isFirstTimer = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    if (_initArgs.isFirstTimer)
                        appn.loadFirstTimeHelp();
                    addEvents();
                }
                connectors.init = init;
                function addEvents() {
                    $('#saveLink').on('click', function () {
                        $('form#appnForm').submit();
                    });
                    $('.connectorOption:not(.connection-required)').on('click', function () {
                        const form = $('form#appnForm');
                        form.append(`<input type="hidden" name="submitType" value="${$(this).attr('id')}" />`);
                        form.submit();
                    });
                    $('.httpVerb').on('change', function () {
                        const connector = $(this).closest('.connector');
                        const formatType = connector.find('.formatType');
                        const verb = $(this).val();
                        if (verb !== 'Post' && verb !== 'Put' && verb !== 'Patch') {
                            formatType.find('option').not('[value="RawJson"]').not('[value="RawXml"]').addClass('d-none');
                            if (formatType.val() !== 'RawJson' && formatType.val() !== 'RawXml') {
                                formatType.val('RawJson');
                                formatType.change();
                            }
                        }
                        else
                            formatType.find('option').removeClass('d-none');
                    });
                }
            })(connectors = taskTemplates.connectors || (taskTemplates.connectors = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
